import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getInfrastructureCategories } from 'shared/thunks/infrastructure';
import { EInfrastructureStatus, IInfrastructure, IInfrastructureCategory } from 'shared/types/infrastructure';

const initialState: IInfrastructure = {
  data: [],
  status: EInfrastructureStatus.Pending,
};

const infrastructureSlice = createSlice({
  initialState,
  name: 'infrastructure',
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getInfrastructureCategories.pending, state => {
        state.status = EInfrastructureStatus.Pending;
      })
      .addCase(getInfrastructureCategories.fulfilled, (_, action: PayloadAction<IInfrastructureCategory[]>) => {
        return {
          data: action.payload,
          status: EInfrastructureStatus.Ready,
        };
      })
      .addCase(
        getInfrastructureCategories.rejected,
        /* istanbul ignore next */ () => {
          return {
            data: [],
            status: EInfrastructureStatus.Failed,
          };
        },
      );
  },
});

export const { reducer: infrastructureReducer } = infrastructureSlice;
